import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import Path from '../../path/ui/Path';
import PromoteContent from '../components/PromoteContent';
import { t } from 'i18next';

function Main() {
    const [bottomBarHidden, setBottomBarHidden] = useState(false);
    const location = useLocation();
    const adData = location.state?.ad || {};

    const handleBottomBarToggle = (isHidden) => {
        setBottomBarHidden(isHidden);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Header onToggleMenu={handleBottomBarToggle} />
            <Path currentPath={t('promote') || 'Жарнама'} />
            <div className="px-4 md:px-[60px] lg:px-[120px] xl:px-[200px] py-6">
                <PromoteContent data={adData} />
            </div>
            {!bottomBarHidden && <MobileBottomBar activeTabName="home" />}
        </div>
    );
}

export default Main;
